const resourceDebounce = 4000;
const taskDelta = 300;
const downloadToRenderDelta = 1000;

const config = {
    __proto__: {
        load
    },

    resourceDebounce,
    taskDelta,
    downloadToRenderDelta,
    log: false,
    bi: false,
    forceBi: false,
    sampleRatio: 0
};

function load(dataset) {
    Object.entries(config)
        .filter(([key]) => dataset.hasOwnProperty(key))
        .map(([key, value]) => [key, typeof value])
        .forEach(([key, type]) => {
            switch (type) {
            case 'boolean':
                config[key] = true;
                break;
            case 'number': {
                const n = Number(dataset[key]);
                if (!Number.isNaN(n)) {
                    config[key] = n;
                }
                break;
            }
            default:
                config[key] = dataset[key];
            }
        });
}

export default config;
